import { useSelector } from 'react-redux';

export const useSchedulesSelector = () => {
  const outlookImportedEvents = useSelector((state) => state.schedules.outlookImportedEvents);
  const outlookImportedEventsIds = useSelector((state) => state.schedules.outlookImportedEvents);
  return { outlookImportedEvents, outlookImportedEventsIds };
};
